import React from 'react'
import { IGeo } from 'interfaces'
import { getGeoLocation } from 'services'
import { environment } from '@/shared/consts/environment'

export const useGeoLocation = () => {
  const [location, setLocation] = React.useState<IGeo>(null)
  const [error, setError] = React.useState<string>(null)

  React.useEffect(() => {
    const geo = async () => {
      try {
        const geoResponse = await getGeoLocation()
        setLocation(geoResponse)
      } catch (error) {
        if (environment.env === 'development') {
          throw new error(error)
        }
        setError("We're unable to fetch your location.Please select one.")
      }
    }
    geo()
  }, [])

  return { location, error }
}
